import { selectHotelWebsite } from 'accessors'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { getCleanUrl } from 'utils/common'

import styles from './EditTextDialog.module.scss'
import { optOutText } from './utils/textContentStrings'

const customLinkUrlRegex = /^(http|https)?:\/\/\S+/i
const previewEncodedShortLinkId = 'hsa88'
const fallbackInviteShortLinkDomain = 'deals.directful.com'

const chainSubdomainByParentChainCode = {
  bestwestern: 'bestwestern',
  choice: 'choicehotels',
  hilton: 'hilton',
  hyatt: 'hyatt',
  ihg: 'ihg',
  marriott: 'marriott',
  radisson: 'radissonhotels',
  sonesta: 'sonesta',
  wyndham: 'wyndhamhotels'
}

export function getInviteShortLinkPreview(subsidiaryShortLinkToken, parentChainCode) {
  const token = subsidiaryShortLinkToken?.trim()
  if (!token) {
    return `on.directful/${previewEncodedShortLinkId}`
  }

  const subdomain = chainSubdomainByParentChainCode[parentChainCode]
  const domain = subdomain
    ? `${subdomain}.directful.com`
    : fallbackInviteShortLinkDomain

  return `${domain}/${token}/${previewEncodedShortLinkId}`
}

export function resolvePreviewLinkUrl(
  customLink,
  hotelWebsiteUrl,
  inviteShortLinkPreview = null
) {
  const custom = customLink?.trim()
  if (custom && customLinkUrlRegex.test(custom)) {
    return custom
  }

  const inviteShortLink = inviteShortLinkPreview?.trim()
  if (inviteShortLink) {
    return inviteShortLink
  }

  const hotel = hotelWebsiteUrl?.trim()
  if (hotel) {
    return getCleanUrl(hotel) || hotel
  }

  return null
}

export const TextPreview = ({ children, header }) => {
  return (
    <div>
      {header && <div className={styles.previewHeader}>{header}</div>}
      <div className={styles.previewDialog}>
        <div className={styles.previewInner}>{children}</div>
      </div>
    </div>
  )
}

export const TextPreviewBubble = ({
  prologue = '',
  text,
  defaultData,
  hasOptOutText,
  hasLink,
  customLink,
  preferShortLink = false
}) => {
  const isDemoMode = useSelector(s => s.login.isDemoMode)
  const hotelWebsiteUrl = useSelector(selectHotelWebsite)
  const subsidiaryShortLinkToken = useSelector(
    s => s.hotelDetails.subsidiaryShortLinkToken
  )
  const parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)

  if (!text) {
    return null
  }

  const inviteShortLinkPreview = preferShortLink
    ? getInviteShortLinkPreview(subsidiaryShortLinkToken, parentChainCode)
    : null
  const url = resolvePreviewLinkUrl(
    customLink,
    hotelWebsiteUrl,
    inviteShortLinkPreview
  )

  function replaceTags(text) {
    const name = defaultData.userName.substring(0, defaultData.userName.indexOf(' '))
    const lastName = defaultData.userName.split(' ').pop() || ''
    const hotelName = isDemoMode ? 'The Luxury Resort & Spa' : defaultData.hotelName
    const promoName = defaultData.promotionName
    return text
      .replace(/@\[(\S+)\]\((__)?(\S+)(__)?\)/gm, '$1')
      .replace('guestName', name)
      .replace('guestLastName', lastName)
      .replace('hotelName', hotelName)
      .replace('promoName', promoName)
      .replace('inviteLink', url ? '|' + url + '|' : '')
      .replace('checkinDate', moment().add(1, 'day').format('MMMM D, YYYY'))
      .replace('checkoutDate', moment().add(3, 'day').format('MMMM D, YYYY'))
      .replace(optOutText, '')
      .split(/\||/g)
      .map((part, i) =>
        url && part === url ? (
          <span className={styles.bubbleLink} key={`t-${i}`}>
            {part}
          </span>
        ) : (
          <span key={`t-${i}`}>{part}</span>
        )
      )
  }
  return (
    <div className={styles.textBubble}>
      <span style={{ opacity: 0.4 }}>{replaceTags(prologue)}</span>
      {replaceTags(text)}
      {hasLink && url && <span className={styles.bubbleLink}>{url}</span>}
      {hasOptOutText && '\n' + optOutText}
      <span className={styles.bubbleTail}></span>
    </div>
  )
}
